export const AUTHOR_KNOWS_ABOUT: Record<string, readonly string[]> = {
	'yaroslav-khaletskyi': ['Brand Strategy', 'Visual Identity', 'Creative Direction'],
	'lubomyr-paladiichuk': ['Brand Operations', 'Design Systems', 'Project Delivery'],
	'kateryna-radziviliuk': ['Content Strategy', 'Brand Communication', 'Copywriting'],
	'bohdan-paladiichuk': ['Brand Strategy', 'Creative Direction', 'Design Leadership'],
	'denys-koloskov': ['UX Design', 'UI Design', 'Design Systems']
};
